import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {getCountries, getInterviewbyid, postResponse} from '../_requets'
import {useAuth} from '../../../modules/auth'
import Swal from 'sweetalert2'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.css'
import {RootState} from '../../../redux/store'
import {useSelector, useDispatch} from 'react-redux'
import {setCountries} from '../../../redux/utils/countrySlice'
import PlacesAutocomplete, {geocodeByAddress, getLatLng} from 'react-places-autocomplete'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {GoogleMap, Marker} from '@react-google-maps/api'
import {Button, Modal, Spinner} from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {parseBold, removeAsterisk} from '../../../utils/parseText'
import toast from 'react-hot-toast'
import {TbParkingCircleFilled} from 'react-icons/tb'
import {BsFuelPumpFill} from 'react-icons/bs'

interface QuestionData {
  title?: string
  titleId?: string
  questionId?: string
  question: string
  type: string
  order: number
  required: boolean
  other: boolean
  comment: boolean
  options: string[]
  reason: boolean
  reasonTitle?: string
  reasonId?: string
  reasonType?: string
  reasonOptions?: string[]
  checkpointId?: string
}

interface InterviewQuestion extends Omit<QuestionData, 'options' | 'reasonOptions' | 'comment'> {
  response: any[]
  comment: string
  reasonResponse: any[]
  coordinates?: {lat: number; lng: number}
}

interface SectionOption {
  option: string
  from: number
  to: number
}

const TimeIntervals = ({interval = 15, index, questions, setQuestions, isReason = false}) => {
  return (
    <div>
      <DatePicker
        selected={
          isReason
            ? questions[index]?.reasonResponse?.[0]
              ? new Date(questions[index].reasonResponse[0])
              : new Date()
            : questions[index]?.response?.[0]
            ? new Date(questions[index].response[0])
            : new Date()
        }
        onChange={(date) => {
          setQuestions((prev) => {
            const updatedFormData = [...prev]
            if (isReason) {
              updatedFormData[index] = {
                ...updatedFormData[index],
                reasonResponse: [date],
              }
            } else {
              updatedFormData[index] = {
                ...updatedFormData[index],
                response: [date],
              }
            }
            return updatedFormData
          })
        }}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={interval}
        dateFormat='h:mm aa'
        className='form-control'
      />
    </div>
  )
}

const InterviewSlidesQuestionaire: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const {currentUser} = useAuth()
  const dispatch = useDispatch()
  const [validateInput, setValidateInput] = useState(false)
  const [data, setData] = useState([])
  const [interviewName, setInterviewName] = useState('')
  const [projectName, setProjectName] = useState('')
  const [questions, setQuestions] = useState<any>([
    {
      title: '',
      titleId: '',
      questionId: '',
      question: '',
      type: '',
      response: [],
      comment: '',
      reasonType: '',
      reasonTitle: '',
      reasonId: '',
      reasonResponse: [],
    },
  ])
  const {countries, loading: countryLoading} = useSelector((state: RootState) => state.country)
  const [locationName, setLocationName] = useState([])
  const [reasonLocationName, setReasonLocationName] = useState([])
  const [bool, setBool] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [coordinates, setCoordinates] = useState<{lat: number; lng: number} | null>(null)
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [startedAt] = useState(new Date())
  const [submitting, setSubmitting] = useState(false)
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  const [checkpoints, setCheckpoints] = useState<
    {index: number; sectionOptions: SectionOption[]}[]
  >([])
  const [skippedQuestionsIndex, setSkippedQuestionsIndex] = useState<number[]>([])
  const [questionNumberList, setQuestionNumberList] = useState<number[]>([])

  const [center, setCenter] = useState({
    lat: 25.276987,
    lng: 55.296249,
  })

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      if (position) {
        setCenter({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        })
      }
    })

    let startY = 0
    let maybePull = false

    const onTouchStart = (e: TouchEvent) => {
      startY = e.touches[0].clientY
      const atTop = (document.scrollingElement?.scrollTop ?? window.pageYOffset) <= 0
      maybePull = atTop
    }

    const onTouchMove = (e: TouchEvent) => {
      if (!maybePull) return
      const dy = e.touches[0].clientY - startY
      if (dy > 0) {
        e.preventDefault()
      } else {
        maybePull = false
      }
    }

    document.addEventListener('touchstart', onTouchStart, {passive: true})
    document.addEventListener('touchmove', onTouchMove, {passive: false})

    return () => {
      document.removeEventListener('touchstart', onTouchStart)
      document.removeEventListener('touchmove', onTouchMove as any)
    }
  }, [])

  const mapContainerStyle = {
    width: '100%',
    height: '400px',
  }

  const closeModal = () => {
    setCoordinates(null)
    setShowModal(false)
  }

  const saveLocation = () => {
    if (coordinates) {
      setQuestions((prev) => {
        const currentIndex = bool.findIndex((b) => b === true)
        if (currentIndex !== -1) {
          const updatedFormData = [...prev]
          updatedFormData[currentIndex] = {
            ...updatedFormData[currentIndex],
            coordinates: coordinates,
          }
          return updatedFormData
        }
        return prev
      })
    }
    setShowModal(false)
  }

  const handleMapClick = (event: any) => {
    setCoordinates({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    })
    setLocationName((prev) => {
      const updatedLocationName = [...prev]
      updatedLocationName[selectedIndex] = ''
      return updatedLocationName
    })
    setQuestions((prev) => {
      const updatedFormData = [...prev]
      updatedFormData[selectedIndex] = {
        ...updatedFormData[selectedIndex],
        coordinates: {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        },
      }
      return updatedFormData
    })
    setBool(Array(questions.length).fill(false))
  }

  const calculateQuestionDisplayInfo = (
    allQuestions: QuestionData[],
    allCheckpoints: typeof checkpoints,
    currentQuestionResponses: InterviewQuestion[]
  ): {questionNumberList: number[]; skippedQuestionsIndex: number[]} => {
    let currentSkippedOrders: number[] = []
    const checkpointOrders = allCheckpoints.map((cp) => cp.index + 1)

    allCheckpoints.forEach((cp) => {
      const checkpointQuestionIndex = allQuestions.findIndex(
        (q) => q.order === cp.index + 1 && q.type === 'checkpoint'
      )

      if (checkpointQuestionIndex !== -1) {
        const checkpointResponseValue =
          currentQuestionResponses[checkpointQuestionIndex]?.response?.[0]
        const allOrdersAfterCheckpoint = allQuestions
          .filter((q) => q.order - 1 > cp.index)
          .map((q) => q.order)

        let ordersToKeep: number[] = []
        const selectedOption = cp.sectionOptions.find(
          (opt) => opt.option === checkpointResponseValue
        )

        if (selectedOption) {
          for (let order = selectedOption.from; order <= selectedOption.to; order++) {
            ordersToKeep.push(order)
          }
        }

        const ordersToSkipFromThisCheckpoint = allOrdersAfterCheckpoint.filter((order) => {
          const isCheckpointQuestion = checkpointOrders.includes(order)
          if (isCheckpointQuestion) {
            return false
          }
          const isInKeepRange = ordersToKeep.includes(order)
          return !isInKeepRange
        })

        ordersToKeep.forEach((order) => {
          if (currentSkippedOrders.includes(order)) {
            currentSkippedOrders = currentSkippedOrders.filter((o) => o !== order)
          }
        })

        currentSkippedOrders.push(...ordersToSkipFromThisCheckpoint)
      }
    })

    const finalSkippedOrders = Array.from(new Set(currentSkippedOrders))
    const titleGroups: any = {}
    const standaloneQuestions: any[] = []
    allQuestions.forEach((element, index) => {
      if (element.title && element.title.trim() !== '') {
        const groupKey = `${element.title}-${element.order}`
        if (!titleGroups[groupKey]) {
          titleGroups[groupKey] = {
            title: element.title,
            order: element.order,
            questions: [],
            indices: [],
          }
        }
        titleGroups[groupKey].questions.push({...element, originalIndex: index})
        titleGroups[groupKey].indices.push(index)
      } else {
        standaloneQuestions.push({...element, originalIndex: index})
      }
    })
    standaloneQuestions.sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
    const sortedGroups = Object.values(titleGroups).sort(
      (a: any, b: any) => (a.order || 0) - (b.order || 0)
    )

    const combinedItems = [
      ...standaloneQuestions.map((q) => ({
        type: 'standalone',
        question: q,
        order: q.order || 0,
        originalOrder: q.order,
      })),
      ...sortedGroups.map((g: any) => ({type: 'group', ...g, originalOrder: g.order})),
    ]
    combinedItems.sort((a, b) => a.order - b.order)

    const numberedListForFlatArray = Array(allQuestions.length).fill(0)
    let finalQuestionNumber = 1

    combinedItems.forEach((item) => {
      const itemOrder = item.originalOrder
      const isCheckpoint = item.type === 'standalone' && item.question.type === 'checkpoint'
      const isVisible = !finalSkippedOrders.includes(itemOrder) || isCheckpoint

      if (isVisible) {
        const indicesToNumber: number[] =
          item.type === 'standalone'
            ? [item.question.originalIndex]
            : item.questions.map((q) => q.originalIndex)

        indicesToNumber.forEach((originalIndex) => {
          numberedListForFlatArray[originalIndex] = finalQuestionNumber
        })
        finalQuestionNumber++
      }
    })

    return {
      questionNumberList: numberedListForFlatArray,
      skippedQuestionsIndex: finalSkippedOrders,
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const res = await getInterviewbyid(params.id)
      setInterviewName(res.interviewName)
      setProjectName(res.project.name)
      const fetchedData: QuestionData[] = res.questions
      setData(fetchedData)
      const initialQuestions: InterviewQuestion[] = fetchedData.map((item, index) => {
        const baseQuestion: InterviewQuestion = {
          title: item.title,
          titleId: item?.titleId || '',
          questionId: item?.questionId || '',
          question: item.question,
          type: item.type,
          response: item.type === 'text' ? item.options : [],
          comment: '',
          reasonType: item.reasonType,
          reasonTitle: item.reasonTitle,
          reasonId: item.reasonId || '',
          reasonResponse: [],
          order: item.order,
          required: item.required,
          other: item.other,
          reason: item.reason,
          checkpointId: item.checkpointId,
        }

        if (item.type === 'location') {
          // @ts-ignore
          baseQuestion.coordinates = item.coordinates
        }
        return baseQuestion
      })

      const sortedCheckpoints = res.checkpoints?.sort((a, b) => a.index - b.index) || []

      setQuestions(initialQuestions)
      setCheckpoints(sortedCheckpoints)
      setBool(Array(fetchedData.length).fill(false))
      setLocationName(Array(fetchedData.length).fill(''))
      setReasonLocationName(Array(fetchedData.length).fill(''))

      const {questionNumberList: initialNumberList, skippedQuestionsIndex: initialSkipped} =
        calculateQuestionDisplayInfo(fetchedData, sortedCheckpoints, initialQuestions)

      setQuestionNumberList(initialNumberList)
      setSkippedQuestionsIndex(initialSkipped)
    }

    fetchData()

    const fetchCountries = async () => {
      const data = await getCountries()
      const temp = data.map((country: {name: {common: string}}) => ({
        label: country?.name?.common,
        value: country?.name?.common,
      }))
      dispatch(setCountries(temp))
    }

    if (countryLoading) {
      fetchCountries()
    }
  }, [])

  const handleFormSubmit = async (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setSubmitting(true)

    const visibleQuestions = questions.filter((_, idx) => {
      const element = data[idx]
      const isSkipped = skippedQuestionsIndex.includes(element.order)
      return element.type === 'checkpoint' || !isSkipped
    })

    const isFormValid = visibleQuestions.every((item, idx) => {
      const originalIndex = data.findIndex(
        (q) => q.order === item.order && q.question === item.question
      )
      const elem = data[originalIndex]

      if (!elem.required) return true

      const response = item.response?.[0]
      switch (item.type) {
        case 'text':
        case 'preference':
          return typeof response === 'string' && response.trim().length >= 3
        case 'number':
          return !isNaN(Number(response))
        case 'date':
        case 'time':
        case 'time-15':
        case 'time-30':
        case 'time-60':
        case 'country':
          return Boolean(response)
        case 'location':
          return (
            item.response.length > 0 &&
            item.coordinates &&
            item.coordinates.lat &&
            item.coordinates.lng
          )
        default:
          return item.response.length > 0
      }
    })

    if (!isFormValid) {
      setValidateInput(true)
      setSubmitting(false)
      await Swal.fire({
        title: 'Validation Error',
        text: 'Please fill in all required fields.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#5856d6',
      })
      return
    }

    const getCurrentLocation = () =>
      new Promise<{lat: number; lng: number}>((resolve, reject) => {
        if (!('geolocation' in navigator)) return reject('Geolocation not supported')
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve({lat: pos.coords.latitude, lng: pos.coords.longitude}),
          (err) => reject(err)
        )
      })

    try {
      const {lat, lng} = await getCurrentLocation()

      const filteredQuestions = questions
        .map((item, idx) => {
          const element = data[idx]
          if (element.type !== 'checkpoint' && skippedQuestionsIndex.includes(element.order)) {
            return null
          }
          return item.type === 'checkbox'
            ? {...item, response: item.response, question: removeAsterisk(item.question)}
            : {...item, question: removeAsterisk(item.question)}
        })
        .filter(Boolean)

      const payload = {
        interviewId: params.id,
        questions: filteredQuestions,
        lat,
        lng,
        createdBy: currentUser?._id,
        startedAt,
      }

      const res = await postResponse(payload)

      if (res) {
        await Swal.fire({
          title: 'Success',
          text: 'Response submitted successfully',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#5856d6',
        })
        navigate('/interview')
      }
    } catch (error) {
      console.error('Error submitting response', error)
    } finally {
      setSubmitting(false)
    }
  }

  const handleSelect = async (address: string, index: number) => {
    try {
      const results = await geocodeByAddress(address)
      const latLng = await getLatLng(results[0])
      setQuestions((prev) => {
        const updatedFormData = [...prev]
        updatedFormData[index] = {
          ...updatedFormData[index],
          response: [address],
          coordinates: {lat: latLng.lat, lng: latLng.lng},
        }
        return updatedFormData
      })
    } catch (error) {
      console.error('Error selecting location', error)
    }
  }

  const handleReasonSelect = async (address: string, index: number) => {
    try {
      setQuestions((prev) => {
        const updatedFormData = [...prev]
        updatedFormData[index] = {
          ...updatedFormData[index],
          reasonResponse: [address],
        }
        return updatedFormData
      })
    } catch (error) {
      console.error('Error selecting location', error)
    }
  }

  const handleInputChange = (index: number, value: any, type: string) => {
    setQuestions((prev) => {
      const updatedFormData = [...prev]
      const parsedValue = parseFloat(value)
      updatedFormData[index] = {
        ...updatedFormData[index],
        response: type === 'text' ? [value] : isNaN(parsedValue) ? [] : [parsedValue],
      }
      return updatedFormData
    })
  }

  const handleInputChangeReason = (index: number, value: any, type: string) => {
    setQuestions((prev) => {
      const updatedFormData = [...prev]
      const parsedValue = parseFloat(value)
      updatedFormData[index] = {
        ...updatedFormData[index],
        reasonResponse: type === 'text' ? [value] : isNaN(parsedValue) ? [] : [parsedValue],
      }
      return updatedFormData
    })
  }

  function handleCheckpointValueChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    index: number
  ) {
    const selectedOptionValue = e.target.value

    const newQuestionsState = questions.map((q, i) =>
      i === index ? {...q, response: [selectedOptionValue]} : q
    )

    const {questionNumberList: newNumberList, skippedQuestionsIndex: newSkippedIndices} =
      calculateQuestionDisplayInfo(data, checkpoints, newQuestionsState)

    setSkippedQuestionsIndex(newSkippedIndices)
    setQuestionNumberList(newNumberList)
    setQuestions(newQuestionsState)
  }

  const getVisibleQuestions = () => {
    const titleGroups: any = {}
    const standaloneQuestions: any[] = []

    data.forEach((element, index) => {
      if (element.title && element.title.trim() !== '') {
        const groupKey = `${element.title}-${element.order}`
        if (!titleGroups[groupKey]) {
          titleGroups[groupKey] = {
            title: element.title,
            order: element.order,
            questions: [],
            indices: [],
          }
        }
        titleGroups[groupKey].questions.push({...element, originalIndex: index})
        titleGroups[groupKey].indices.push(index)
      } else {
        standaloneQuestions.push({...element, originalIndex: index})
      }
    })

    standaloneQuestions.sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
    const sortedGroups = Object.values(titleGroups).sort(
      (a: any, b: any) => (a.order || 0) - (b.order || 0)
    )

    const allItems = [
      ...standaloneQuestions.map((q) => ({
        type: 'standalone',
        question: q,
        order: q.order || 0,
      })),
      ...sortedGroups.map((g: any) => ({type: 'group', ...g})),
    ]
    allItems.sort((a, b) => (a.order || 0) - (b.order || 0))

    return allItems.filter((item) => {
      const itemOrder = item.type === 'standalone' ? item.question.order : item.order
      const isSkipped = skippedQuestionsIndex.includes(itemOrder)
      return !isSkipped
    })
  }

  const validateCurrentQuestion = (item: any, displayNumber: number) => {
    if (item.type === 'standalone') {
      const element = item.question
      const index = element.originalIndex
      const questionData = questions[index]

      if (!element.required) return true

      const response = questionData.response?.[0]
      switch (element.type) {
        case 'text':
          return typeof response === 'string' && response.trim().length >= 3
        case 'number':
          return !isNaN(Number(response))
        case 'date':
        case 'time':
        case 'time-15':
        case 'time-30':
        case 'time-60':
        case 'country':
          return Boolean(response)
        case 'location':
          return (
            questionData.response.length > 0 &&
            questionData.coordinates &&
            questionData.coordinates.lat &&
            questionData.coordinates.lng
          )
        default:
          return questionData.response.length > 0
      }
    } else {
      return item.questions.every((element) => {
        const index = element.originalIndex
        const questionData = questions[index]
        if (!element.required) return true
        return questionData.response && questionData.response.length > 0
      })
    }
  }

  const handleNext = () => {
    const visibleQuestions = getVisibleQuestions()
    const currentItem = visibleQuestions[currentSlideIndex]

    if (!validateCurrentQuestion(currentItem, currentSlideIndex + 1)) {
      setValidateInput(true)
      toast.error('Please fill in all required fields before proceeding.')
      return
    }

    setValidateInput(false)
    if (currentSlideIndex < visibleQuestions.length - 1) {
      setCurrentSlideIndex(currentSlideIndex + 1)
    }
  }

  const handlePrevious = () => {
    setValidateInput(false)
    if (currentSlideIndex > 0) {
      setCurrentSlideIndex(currentSlideIndex - 1)
    }
  }

  const renderQuestionInput = (element: any, index: number) => {
    return (
      <>
        {element.type === 'text' && (
          <div>
            <input
              type='text'
              className='form-control form-control-lg'
              placeholder={removeAsterisk(element.question)}
              required={element.required}
              value={questions[index].response[0] ?? ''}
              onChange={(e) => handleInputChange(index, e.target.value, 'text')}
            />
            {element.required &&
              validateInput &&
              (questions[index].response?.[0] === undefined ||
                questions[index].response[0]?.length < 3) && (
                <div className='alert alert-danger mt-3' role='alert'>
                  Input cannot be less than 3 characters!
                </div>
              )}
          </div>
        )}
        {element.type === 'number' && (
          <div>
            <input
              type='number'
              className='form-control form-control-lg'
              placeholder={removeAsterisk(element.question)}
              required={element.required}
              value={questions[index].response[0] ?? ''}
              onChange={(e) => handleInputChange(index, e.target.value, 'number')}
            />
            {element.required &&
              validateInput &&
              (questions[index].response[0] === '' || isNaN(questions[index].response[0])) && (
                <div className='alert alert-danger mt-3' role='alert'>
                  Input must be a valid number!
                </div>
              )}
          </div>
        )}
        {element.type === 'checkbox' && (
          <div className='d-flex flex-column gap-3'>
            {element.options.map((currElem, idx) => (
              <label
                key={idx}
                className={`form-check form-check-custom form-check-solid p-4 border rounded cursor-pointer ${
                  questions[index].response.includes(currElem)
                    ? 'border-primary bg-light-primary'
                    : 'border-gray-300 hover-border-primary'
                }`}
              >
                <input
                  type='checkbox'
                  className='form-check-input'
                  value={currElem}
                  checked={questions[index].response.includes(currElem)}
                  onChange={(e) =>
                    setQuestions((prev) => {
                      const updatedFormData = [...prev]
                      if (e.target.checked) {
                        updatedFormData[index] = {
                          ...updatedFormData[index],
                          response: [...updatedFormData[index].response, e.target.value],
                        }
                      } else {
                        updatedFormData[index] = {
                          ...updatedFormData[index],
                          response: updatedFormData[index].response.filter(
                            (item) => item !== e.target.value
                          ),
                        }
                      }
                      return updatedFormData
                    })
                  }
                />
                <span className='form-check-label fs-5'>{currElem}</span>
              </label>
            ))}
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='alert alert-danger mt-2' role='alert'>
                This option is required
              </div>
            )}
          </div>
        )}

        {element.type === 'multiple' && (
          <div className='d-flex flex-column gap-3'>
            {element.options.map((currElem, idx) => (
              <label
                key={idx}
                className={`form-check form-check-custom form-check-solid p-4 border rounded cursor-pointer ${
                  questions[index].response[0] === currElem
                    ? 'border-primary bg-light-primary'
                    : 'border-gray-300 hover-border-primary'
                }`}
              >
                <input
                  type='radio'
                  name={`radio${index}`}
                  className='form-check-input'
                  required={element.required}
                  value={currElem}
                  checked={questions[index].response[0] === currElem}
                  onChange={(e) =>
                    setQuestions((prev) => {
                      const updatedFormData = [...prev]
                      updatedFormData[index] = {
                        ...updatedFormData[index],
                        response: [e.target.value],
                      }
                      return updatedFormData
                    })
                  }
                />
                <span className='form-check-label fs-5'>{currElem}</span>
              </label>
            ))}
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='alert alert-danger mt-2' role='alert'>
                This option is required
              </div>
            )}
          </div>
        )}

        {element.type === 'preference' && (
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            {element.preferenceOptions?.map((option, optIdx) => {
              const responseString = `${option.title}, AED ${option.totalCost}, ${option.totalTime}`
              const isSelected = questions[index].response[0] === responseString

              return (
                <div
                  key={optIdx}
                  className={`d-flex flex-column justify-content-between border rounded-lg p-4 cursor-pointer transition-all ${
                    isSelected
                      ? 'bg-light-primary border-primary shadow-md'
                      : 'border-secondary hover:border-primary'
                  }`}
                  onClick={() =>
                    setQuestions((prev) => {
                      const updatedFormData = [...prev]
                      updatedFormData[index] = {
                        ...updatedFormData[index],
                        response: [responseString],
                      }
                      return updatedFormData
                    })
                  }
                >
                  <div className='flex items-center gap-3 mb-3'>
                    <img
                      src={toAbsoluteUrl(`/media/svg/preference/${option.icon || 'car'}.svg`)}
                      alt={option.title}
                      className='w-50 h-50'
                    />
                    <h4 className='mb-0 font-semibold text-lg'>{option.title}</h4>
                  </div>

                  <div className='space-y-2 mb-3'>
                    {option.fuel > 0 && (
                      <div className='flex items-center gap-2 text-sm text-gray-600'>
                        <BsFuelPumpFill className='fs-6' />
                        <span>Fuel</span>
                        <span className='ml-auto font-medium'>{option.fuel} AED</span>
                      </div>
                    )}
                    {option.fare > 0 && (
                      <div className='flex items-center gap-2 text-sm text-gray-600'>
                        <KTIcon iconName='price-tag' className='fs-6' />
                        <span>Fare</span>
                        <span className='ml-auto font-medium'>{option.fare} AED</span>
                      </div>
                    )}
                    {option.tolls > 0 && (
                      <div className='flex items-center gap-2 text-sm text-gray-600'>
                        <KTIcon iconName='purchase' className='fs-6' />
                        <span>Tolls</span>
                        <span className='ml-auto font-medium'>{option.tolls} AED</span>
                      </div>
                    )}
                    {option.parking > 0 && (
                      <div className='flex items-center gap-2 text-sm text-gray-600'>
                        <TbParkingCircleFilled className='fs-6' />
                        <span>Parking</span>
                        <span className='ml-auto font-medium'>{option.parking} AED</span>
                      </div>
                    )}
                    {option.toFrom && (
                      <div className='flex items-center gap-2 text-sm text-gray-600'>
                        <KTIcon iconName='route' className='fs-6' />
                        <span>To/from stations</span>
                        <span className='ml-auto font-medium'>{option.toFrom}</span>
                      </div>
                    )}
                    {option.timeToTravel && (
                      <div className='flex items-center gap-2 text-sm text-gray-600'>
                        <KTIcon iconName='time' className='fs-6' />
                        <span>Time on train</span>
                        <span className='ml-auto font-medium'>{option.timeToTravel}</span>
                      </div>
                    )}
                  </div>

                  <div className='flex gap-2 mt-4'>
                    <div className='flex-1 border border-gray-300 rounded p-2 text-center'>
                      <div className='text-xs text-gray-500 mb-1'>Total Cost</div>
                      <div className='font-semibold'>{option.totalCost} AED</div>
                    </div>
                    <div className='flex-1 border border-gray-300 rounded p-2 text-center'>
                      <div className='text-xs text-gray-500 mb-1'>Total Time</div>
                      <div className='font-semibold'>{option.totalTime}</div>
                    </div>
                  </div>
                </div>
              )
            })}
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='col-span-full alert alert-danger mt-2' role='alert'>
                Please select a preference
              </div>
            )}
          </div>
        )}

        {element.type === 'dropdown' && (
          <div>
            <select
              className='form-select form-select-lg'
              required={element.required}
              defaultValue=''
              onChange={(e) =>
                setQuestions((prev) => {
                  const updatedFormData = [...prev]
                  updatedFormData[index] = {
                    ...updatedFormData[index],
                    response: [e.target.value],
                  }
                  return updatedFormData
                })
              }
            >
              <option value=''>Select an option</option>
              {element.options.map((currElem, idx) => (
                <option key={idx} value={currElem}>
                  {currElem}
                </option>
              ))}
            </select>
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='alert alert-danger mt-3' role='alert'>
                This option is required
              </div>
            )}
          </div>
        )}

        {element.type === 'date' && (
          <div>
            <Flatpickr
              className='form-control form-control-lg'
              placeholder={removeAsterisk(element.question)}
              required={element.required}
              options={{
                dateFormat: 'd-m-Y',
              }}
              value={questions[index].response ? new Date(questions[index].response[0]) : ''}
              onChange={(date) =>
                setQuestions((prev) => {
                  const updatedFormData = [...prev]
                  updatedFormData[index] = {
                    ...updatedFormData[index],
                    response: [new Date(date).toISOString()],
                  }
                  return updatedFormData
                })
              }
            />
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='alert alert-danger mt-3' role='alert'>
                Date is required
              </div>
            )}
          </div>
        )}

        {element.type === 'time' && (
          <div>
            <Flatpickr
              className='form-control form-control-lg'
              placeholder={removeAsterisk(element.question)}
              required={element.required}
              options={{
                enableTime: true,
                noCalendar: true,
                dateFormat: 'H:i',
                time_24hr: true,
              }}
              value={questions[index].response ? new Date(questions[index].response[0]) : ''}
              onChange={(date) =>
                setQuestions((prev) => {
                  const updatedFormData = [...prev]
                  updatedFormData[index] = {
                    ...updatedFormData[index],
                    response: [new Date(date).toISOString()],
                  }
                  return updatedFormData
                })
              }
            />
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='alert alert-danger mt-3' role='alert'>
                Time is required
              </div>
            )}
          </div>
        )}

        {element.type === 'time-15' && (
          <div>
            <TimeIntervals
              interval={15}
              index={index}
              questions={questions}
              setQuestions={setQuestions}
            />
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='alert alert-danger mt-3' role='alert'>
                Time is required
              </div>
            )}
          </div>
        )}

        {element.type === 'time-30' && (
          <div>
            <TimeIntervals
              interval={30}
              index={index}
              questions={questions}
              setQuestions={setQuestions}
            />
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='alert alert-danger mt-3' role='alert'>
                Time is required
              </div>
            )}
          </div>
        )}

        {element.type === 'time-60' && (
          <div>
            <TimeIntervals
              interval={60}
              index={index}
              questions={questions}
              setQuestions={setQuestions}
            />
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='alert alert-danger mt-3' role='alert'>
                Time is required
              </div>
            )}
          </div>
        )}

        {element.type === 'country' && (
          <div>
            <Select
              options={countries}
              className='react-select-styled'
              classNamePrefix='react-select'
              onChange={(e) =>
                setQuestions((prev) => {
                  const updatedFormData = [...prev]
                  updatedFormData[index] = {
                    ...updatedFormData[index],
                    response: [e?.value || ''],
                  }
                  return updatedFormData
                })
              }
              isClearable
              filterOption={(option, inputValue) =>
                option.label.toLowerCase().startsWith(inputValue.toLowerCase())
              }
            />
            {element.required && validateInput && questions[index].response.length < 1 && (
              <div className='alert alert-danger mt-3' role='alert'>
                Country is required
              </div>
            )}
          </div>
        )}

        {element.type === 'location' && (
          <div>
            <input
              type='text'
              className='form-control form-control-lg mb-3'
              placeholder={removeAsterisk(element.question)}
              required={element.required}
              value={questions[index].response[0] ?? ''}
              onChange={(e) => handleInputChange(index, e.target.value, 'text')}
            />
            <div className='d-flex gap-2'>
              <PlacesAutocomplete
                value={locationName[index]}
                onChange={(value) =>
                  setLocationName((prev) => {
                    const updatedLocationName = [...prev]
                    updatedLocationName[index] = value
                    return updatedLocationName
                  })
                }
                onSelect={(value) => handleSelect(value, index)}
                searchOptions={{
                  location: new google.maps.LatLng(25.276987, 55.296249),
                  radius: 300000,
                  componentRestrictions: {country: 'ae'},
                }}
              >
                {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                  <div className='flex-grow-1'>
                    <input
                      {...getInputProps({
                        placeholder: 'Search Location...',
                        className: 'form-control form-control-lg',
                      })}
                    />
                    <div className='autocomplete-dropdown-container'>
                      {loading && <div className='p-2'>Loading...</div>}
                      {suggestions.map((suggestion) => (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className: suggestion.active
                              ? 'suggestion-item--active'
                              : 'suggestion-item',
                          })}
                          key={suggestion.placeId}
                          className='p-2 cursor-pointer hover-bg-light-primary border-bottom'
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>
              <button
                type='button'
                className='btn btn-light-primary btn-lg'
                onClick={() => {
                  setBool((prev) => {
                    const updatedBool = Array(prev.length).fill(false)
                    updatedBool[index] = true
                    return updatedBool
                  })
                  setSelectedIndex(index)
                  setCoordinates(questions[index].coordinates)
                  if (questions[index].coordinates) {
                    setCenter({
                      lat: questions[index].coordinates.lat,
                      lng: questions[index].coordinates.lng,
                    })
                  }
                  setShowModal(true)
                }}
                title='Choose Location'
              >
                <KTIcon iconName='map' className='fs-2' />
              </button>
            </div>
            {questions[index].coordinates && (
              <div className='mt-3 p-3 bg-light rounded'>
                <p className='mb-1'>
                  <strong>Latitude:</strong> {questions[index].coordinates.lat}
                </p>
                <p className='mb-0'>
                  <strong>Longitude:</strong> {questions[index].coordinates.lng}
                </p>
              </div>
            )}
            {element.required &&
              validateInput &&
              (!questions[index].response ||
                questions[index].response.length === 0 ||
                !questions[index].coordinates) && (
                <div className='alert alert-danger mt-3' role='alert'>
                  Location is required!
                </div>
              )}
          </div>
        )}
        {element.other && (
          <div className='mt-3'>
            <input
              type='text'
              className='form-control form-control-lg'
              placeholder='Other (Please Specify)'
              onChange={(e) =>
                setQuestions((prev) => {
                  const updatedFormData = [...prev]
                  updatedFormData[index] = {
                    ...updatedFormData[index],
                    response: [e.target.value],
                  }
                  return updatedFormData
                })
              }
            />
          </div>
        )}
        {element.comment && (
          <div className='mt-3'>
            <input
              type='text'
              className='form-control form-control-lg'
              placeholder='Comment'
              value={questions[index].comment}
              onChange={(e) =>
                setQuestions((prev) => {
                  const updatedFormData = [...prev]
                  updatedFormData[index] = {
                    ...updatedFormData[index],
                    comment: e.target.value,
                  }
                  return updatedFormData
                })
              }
            />
          </div>
        )}
      </>
    )
  }

  const renderCheckpointQuestionInput = (element: QuestionData, index: number) => {
    const currentCheckpoint = checkpoints.find((cp) => cp.index === element.order - 1)
    const optionsToRender = currentCheckpoint ? currentCheckpoint.sectionOptions : []

    return (
      <div className='d-flex flex-column gap-3'>
        {optionsToRender.map((currElem, idx) => (
          <label
            key={idx}
            className={`form-check form-check-custom form-check-solid p-4 border rounded cursor-pointer ${
              questions[index].response[0] === currElem.option
                ? 'border-primary bg-light-primary'
                : 'border-gray-300 hover-border-primary'
            }`}
          >
            <input
              type='radio'
              name={`radio${index}`}
              className='form-check-input'
              required={element.required}
              value={currElem.option}
              checked={questions[index].response[0] === currElem.option}
              onChange={(e) =>
                handleCheckpointValueChange(e as React.ChangeEvent<HTMLInputElement>, index)
              }
            />
            <span className='form-check-label fs-5'>{currElem.option}</span>
          </label>
        ))}
        {element.required && validateInput && questions[index].response.length < 1 && (
          <div className='alert alert-danger mt-2' role='alert'>
            This option is required
          </div>
        )}
      </div>
    )
  }

  const renderRankQuestions = (data: any[], questionNumber: number) => {
    return (
      <div>
        {data?.map((element, subIndex) => {
          const idx = element.originalIndex
          return (
            <div key={`rank-${subIndex}`} className='mb-5'>
              <p className='fs-5 fw-semibold text-gray-800 mb-3'>
                <span
                  dangerouslySetInnerHTML={{
                    __html: parseBold(element.question),
                  }}
                />{' '}
                {element.required && <span className='text-danger'>*</span>}
              </p>

              <div className='d-flex gap-3 flex-wrap'>
                {element?.options?.map((option, optIndex) => {
                  const isSelected = questions[idx]?.response?.[0] === option
                  return (
                    <label
                      key={`option-${optIndex}`}
                      className={`btn ${option?.length > 3 ? 'btn-sm' : 'btn-lg min-w-75px'} ${
                        isSelected ? 'btn-primary' : 'btn-light-primary border border-primary'
                      } `}
                    >
                      <input
                        type='radio'
                        className='d-none'
                        name={`question-${idx}`}
                        value={option}
                        checked={isSelected}
                        onChange={(e) => {
                          setQuestions((prev) => {
                            const updatedFormData = [...prev]
                            updatedFormData[idx] = {
                              ...updatedFormData[idx],
                              response: [e.target.value],
                            }
                            return updatedFormData
                          })
                        }}
                      />
                      <span className={`fw-bold ${option.length > 3 ? 'fs-4' : 'fs-2'}`}>
                        {option}
                      </span>
                    </label>
                  )
                })}
              </div>

              {element.required && validateInput && questions[idx].response.length < 1 && (
                <div className='alert alert-danger mt-3' role='alert'>
                  This question is required
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  const visibleQuestions = getVisibleQuestions()
  const totalQuestions = visibleQuestions.length
  const currentItem = visibleQuestions[currentSlideIndex]

  if (!currentItem) return null

  let displayQuestionNumber = 0
  if (currentItem.type === 'standalone') {
    displayQuestionNumber = questionNumberList[currentItem.question.originalIndex]
  } else {
    const firstQuestionIndex = currentItem.questions[0]?.originalIndex
    if (firstQuestionIndex !== undefined) {
      displayQuestionNumber = questionNumberList[firstQuestionIndex]
    }
  }

  const progressPercentage =
    totalQuestions > 0 ? Math.round(((currentSlideIndex + 1) / totalQuestions) * 100) : 0

  return (
    <section className='d-flex align-items-center'>
      <div className='container-fluid'>
        <div className='row justify-content-center'>
          <div className='col-12 col-lg-10 col-xl-8'>
            <div className='px-4'>
              {/* Header Card */}
              <div className='card shadow-sm mb-4'>
                <div className='card-body p-6'>
                  <div className='d-flex align-items-start'>
                    <div className='symbol symbol-50px bg-light-primary me-4'>
                      <div className='symbol-label'>
                        <KTIcon iconName='questionnaire-tablet' className='fs-2x text-primary' />
                      </div>
                    </div>
                    <div className='flex-grow-1'>
                      <h1 className='fs-2 fw-bold text-gray-900 mb-2'>{interviewName}</h1>
                      <p className='text-gray-600 mb-3'>{projectName}</p>
                      <div className='d-flex align-items-center gap-4 flex-wrap'>
                        <div className='d-flex align-items-center'>
                          <KTIcon iconName='lots-shopping' className='fs-5 text-gray-500 me-2' />
                          <span className='text-gray-600 fs-6'>{totalQuestions} questions</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Progress Indicator */}
              <div className='card shadow-sm mb-4'>
                <div className='card-body p-4'>
                  <div className='d-flex justify-content-between align-items-center mb-2'>
                    <span className='fw-semibold text-gray-800 fs-6'>
                      Question {currentSlideIndex + 1} of {totalQuestions}
                    </span>
                    <span className='fw-bold text-primary fs-5'>{progressPercentage}%</span>
                  </div>
                  <div className='progress h-8px bg-light-primary'>
                    <div
                      className='progress-bar bg-primary'
                      role='progressbar'
                      style={{width: `${progressPercentage}%`, transition: 'width 0.3s ease'}}
                      aria-valuenow={progressPercentage}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    ></div>
                  </div>
                </div>
              </div>

              {/* Question Card */}
              <div className='card shadow-sm mb-4'>
                <div className='card-body p-6 p-lg-8'>
                  <div>
                    <span className='badge badge-light-primary text-uppercase fw-bold fs-7 mb-4'>
                      Question {displayQuestionNumber || currentSlideIndex + 1}
                    </span>
                    {currentItem.type === 'standalone' ? (
                      <>
                        <h2 className='fs-2 fw-bold text-gray-900 mb-5'>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: parseBold(currentItem.question.question),
                            }}
                          />
                          {currentItem.question.required && (
                            <span className='text-danger ms-1'>*</span>
                          )}
                        </h2>
                        {(() => {
                          const element = currentItem.question
                          const index = element.originalIndex
                          return (
                            <div>
                              {element.type === 'checkpoint'
                                ? renderCheckpointQuestionInput(element, index)
                                : renderQuestionInput(element, index)}
                            </div>
                          )
                        })()}
                      </>
                    ) : (
                      <>
                        <h2 className='fs-2 fw-bold text-gray-900 mb-5'>{currentItem.title}</h2>
                        <div>
                          {currentItem.questions.map((element, subIndex) => {
                            const isRank = element.type === 'rank'
                            const index = element.originalIndex

                            if (isRank) {
                              if (subIndex === 0) {
                                return renderRankQuestions(
                                  currentItem.questions,
                                  displayQuestionNumber
                                )
                              }
                              return (
                                <React.Fragment
                                  key={`sub-rank-spacer-${subIndex}`}
                                ></React.Fragment>
                              )
                            }

                            const isIndividualSkipped = skippedQuestionsIndex.includes(
                              element.order
                            )
                            if (isIndividualSkipped) return null

                            return (
                              <div key={`sub-${subIndex}`} className='mb-6'>
                                <p className='fs-4 fw-semibold text-gray-800 mb-3'>
                                  <span
                                    dangerouslySetInnerHTML={{__html: parseBold(element.question)}}
                                  />
                                  {element.required && <span className='text-danger ms-1'>*</span>}
                                </p>
                                {renderQuestionInput(element, index)}
                              </div>
                            )
                          })}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Navigation Buttons */}
              <div className='d-flex justify-content-between gap-3'>
                <button
                  type='button'
                  onClick={handlePrevious}
                  disabled={currentSlideIndex === 0}
                  className='btn btn-secondary btn-lg d-flex align-items-center px-6'
                >
                  <KTIcon iconName='arrow-left' className='fs-3 me-2' />
                  <span className='fw-semibold'>Previous</span>
                </button>
                {currentSlideIndex < totalQuestions - 1 ? (
                  <button
                    type='button'
                    onClick={handleNext}
                    className='btn btn-primary btn-lg d-flex align-items-center px-6'
                  >
                    <span className='fw-semibold'>Next</span>
                    <KTIcon iconName='arrow-right' className='fs-3 ms-2' />
                  </button>
                ) : (
                  <button
                    type='button'
                    onClick={handleFormSubmit}
                    disabled={submitting}
                    className='btn btn-primary btn-lg px-8'
                  >
                    {submitting ? (
                      <>
                        <Spinner animation='border' size='sm' className='me-2' /> Submitting...
                      </>
                    ) : (
                      <span className='fw-semibold'>Submit Interview</span>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <Modal show={showModal} onHide={closeModal} size='lg' backdrop='static'>
          <Modal.Header closeButton>
            <Modal.Title>Choose your Location</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='card-body py-4'>
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={center}
                zoom={14}
                onClick={(e) => {
                  handleMapClick(e)
                }}
              >
                {coordinates && <Marker position={coordinates}></Marker>}
              </GoogleMap>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='primary' onClick={saveLocation}>
              Save
            </Button>
            <Button variant='secondary' onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </section>
  )
}

export default InterviewSlidesQuestionaire
